import type { SVGProps } from 'react';
import { AnimalFace } from './AnimalFace';

export function AnimalChimp(props: SVGProps<SVGSVGElement>) {
  return (
    <AnimalFace size={150} {...props}>

  <>
    <path
      d="M124.609 53.355C117.928 43.21 107.15 37.8 94.327 35.48 66.784 30.5 34.464 30.822 24.08 62.536c-4.552 13.913.495 35.994 8.98 47.17 5.091 6.713 13.826 20.004 42.888 20.287 34.774.339 46.962-26.162 52.189-41.004 4.347-12.357 3.797-24.515-3.528-35.634z"
      fill="#D37F45"
    />
    <path
      d="M111.342 56.402c-9.876-7.82-26.458-5.848-33.922 5.167-7.92-8.104-26.96-16.837-40.59-2.742-7.756 8.021-6.206 23.39.624 30.454-4.968 10.759 3.477 22.607 7.425 26.318 8.87 8.329 22.189 11.497 31.98 11.162 8.535-.291 14.488-.595 26.405-8.694 5.854-3.98 18.945-15.877 9.629-31.245 3.724-2.763 12.417-19.357-1.551-30.42"
      fill="#FCD09A"
    />
    <path
      d="M24.084 62.537c2.814-8.59 7.246-14.86 12.745-19.361-2.712-4.97-8.926-9.69-15.347-10.554C10.347 31.127 3.19 37.254 1.623 44.357c-4.083 18.428 12.909 22.53 21.535 21.774.251-1.247.556-2.451.926-3.594z"
      fill="#CB7341"
    />
    <path
      d="M32.325 47.552c-3.41-5.105-8.67-9.072-13.639-8.103-4.014.786-9.882 2.763-9.987 10.627-.092 6.944 7.888 10.78 15.965 10.85 1.946-5.353 4.544-9.772 7.66-13.374"
      fill="#F68276"
    />
    <path
      d="M147.097 42.289c-3.268-6.587-7.043-10.22-14.393-10.294-7.289-.07-14.762 4.632-18.855 10.75 4.236 2.746 7.883 6.235 10.767 10.61 2.751 4.172 4.543 8.495 5.486 12.918 11.484-.704 22.794-12.31 16.995-23.984z"
      fill="#CB7341"
    />
    <path
      d="M141.012 43.367c-4.3-7.839-17.327-3.363-22.318 3.098a35.895 35.895 0 015.921 6.895 39.11 39.11 0 013.812 7.378c7.106-1.438 18.003-7.478 12.585-17.371z"
      fill="#F68276"
    />
    <path
      d="M83.763 33.91c2.308-2.138 5.324-3.75 9.62-4.35-4.34-2.341-10.029-1.329-13.582-.008 1.489-2.954 3.596-5.483 7.326-8.55-6.108.06-11.384 4.118-15.86 8.272a36.456 36.456 0 013.158-6.205c-5.294 1.938-8.729 6.057-10.75 10.35 6.54-.552 13.352-.278 20.088.491"
      fill="#D37F45"
    />
    <path
      d="M85.047 102.807c-.15-2.746-16.273-3.22-16.739-.1-.527 3.563 4.382 6.283 8.647 6.139 4.26-.143 8.29-2.385 8.092-6.039zM66.614 115.873c6.376 4.523 14.628 4.562 20.953-.083.85-.626.023-2.064-.837-1.429-5.89 4.323-13.334 4.301-19.28.082-.874-.621-1.701.817-.836 1.43"
      fill="#1F1611"
    />
    <path
      d="M99.094 101.619c-3.248 5.692 7.986 10.05 11.916 3.924 1.736-2.707-.161-5.123-3.34-6.235-3.208-1.121-6.948-.548-8.576 2.311M44.213 100.131c-5.863 3.419-1.05 12.166 7.729 8.047 7.5-3.52-1.01-11.963-7.729-8.047z"
      fill="#F68276"
    />
    <path
      d="M97.005 87.775c-1.839 5.935 3.204 10.111 6.105 5.127 1.505-2.589.825-5.761-.835-7.13-1.66-1.368-4.353-.965-5.27 2.003z"
      fill="#1F1611"
    />
    <path
      d="M104.891 74.673c.575.248 1.145.504 1.71.773.273.135.541.274.808.417.2.113.96.704.351.183.94.804 2.28.925 3.205 0 .828-.821.945-2.403 0-3.207-1.101-.947-2.46-1.52-3.784-2.085-1.135-.491-2.421-.352-3.103.813-.565.968-.322 2.615.813 3.106M45.655 71.99c-1.47.379-2.807 1.173-4 2.095-.981.752-1.501 1.933-.82 3.102.565.965 2.125 1.573 3.107.817a15.687 15.687 0 011.57-1.073c.273-.161.555-.296.842-.43-.322.152.426-.114.511-.135 1.193-.305 1.906-1.612 1.583-2.79-.332-1.207-1.592-1.894-2.793-1.585"
      fill="#E3B36B"
    />
    <path
      d="M49.715 87.55c-3.82 2.676.4 12.044 4.31 8.086 4.264-4.32-.482-10.767-4.31-8.086z"
      fill="#1F1611"
    />
    <path fill="#fff" fillOpacity={0.01} d="M149 149h1v1h-1z" />
  </>
    </AnimalFace>
  );
}
